import { Alert, AlertTitle, Typography } from '@mui/material';
import { useTranslation } from 'react-i18next';

const getSeverity = (result) => {
  if (result.connected && result.folders.every((folder) => folder.accessible)) {
    return 'success';
  }
  return 'error';
};

const ConnectionTestResult = ({ result }) => {
  const { t } = useTranslation();

  if (!result) {
    return null;
  }

  const getTitle = () => {
    if (result.connected) {
      return t('managedAccounts.paymentsManager.test.connected');
    }
    return t('managedAccounts.paymentsManager.test.connectionFailed');
  };

  const getErrorMessage = () => {
    if (result.connectionError === 'authentication_failed') {
      return t('managedAccounts.paymentsManager.test.authenticationFailed');
    }
    if (result.connectionError === 'invalid_configuration') {
      return t('managedAccounts.paymentsManager.test.invalidConfiguration');
    }
    return t('managedAccounts.paymentsManager.test.serverUnreachable');
  };

  const getFolderLabel = (folder) => {
    if (folder.accessible) {
      return t('managedAccounts.paymentsManager.test.accessible');
    }
    return t('managedAccounts.paymentsManager.test.inaccessible');
  };

  return (
    <Alert severity={getSeverity(result)} sx={{ mb: 3 }}>
      <AlertTitle>{getTitle()}</AlertTitle>
      {result.connectionError && (
        <Typography variant='body2'>{getErrorMessage()}</Typography>
      )}
      {result.folders.map((folder) => (
        <Typography variant='body2' key={folder.path}>
          {getFolderLabel(folder)}: {folder.path}
        </Typography>
      ))}
    </Alert>
  );
};

export default ConnectionTestResult;
